import type { DeploymentEvent } from "./useDeploymentEvents";

/**
 * Normalize a DeploymentEvent from the API or WebSocket.
 *
 * Defensive transforms:
 *  1. `metadata` is double-serialized JSON from the backend — parse it to an object.
 *  2. Required string fields (`eventType`, `step`, `status`, `message`, `sagaId`)
 *     are defaulted to empty strings if missing, preventing "Cannot read properties
 *     of undefined" crashes in downstream hooks.
 */
export function normalizeEvent(raw: DeploymentEvent): DeploymentEvent {
  const meta = raw.metadata;
  return {
    ...raw,
    eventType: raw.eventType ?? "",
    step: raw.step ?? "",
    status: raw.status ?? "unknown",
    message: raw.message ?? "",
    sagaId: raw.sagaId ?? "",
    severity: raw.severity ?? "info",
    metadata:
      typeof meta === "string"
        ? (JSON.parse(meta) as Record<string, unknown>)
        : ((meta as Record<string, unknown>) ?? undefined),
  };
}
